<template>
  <div>
    <script v-html="jsonld" type="application/ld+json"></script>
    <!-- <section>
      <slick ref="cinemaSlick">
        <div>
          <div class="slider-container">
            <div class="row mx-0 h-100">
              <div class="col-6 col-sm-6 col-lg-4 col-xl-3 px-0">
                <div class="poster-container"></div>
                <img :src="cinemaDetails.ThumbnailImage" class="cinema-poster" alt>
              </div> 
              <div class="col-6 col-sm-6 col-lg-8 col-xl-9 py-3">
                <div>
                  <div class="slider-title">{{cinemaDetails.CinemaName}}</div> 
                </div>

                <p class="cinema-info d-none d-md-block">{{cinemaDetails.Location}}</p> 
              </div> 
              <div class="col-12 px-2 pb-3 d-md-none">
                <hr>
                <p class="cinema-info">Phone : {{cinemaDetails.Phone}}</p>
              </div>
            </div>
          </div>
        </div>
      </slick>
    </section>-->

    <div class="wrapper">
      <section class="movieDetailsBanner">
        <div class="d-flex">
          <div class="d-flex align-items-center">
            <div class="poster_img">
              <img
                v-if="cinemaDetails.ThumbnailImage.includes('/assets')"
                :src="'http://img.ticketak.com' + cinemaDetails.ThumbnailImage"
                class="img-fluid"
                alt
              />
              <!-- {{cinemaDetails.CinemaName.includes('AKIL')}} -->

              <img
                v-else-if="project == 'ticketak'"
                src="@/assets/img/app_logo_single.png"
                class="img-fluid"
                alt
              />
              <img
                v-else
                src="@/assets/img/325-x-488.jpg"
                class="img-fluid"
                alt
              />
              <!-- <a :href="trailer.url" data-fancybox class="btn-play"></a> -->
            </div>
          </div>
          <div class="movie_content w-75 mx-2 px-md-3 mt-2 mt-md-4">
            <!-- FIRST ROW -->
            <div class="lh-1 mb-md-3 mb-lg-4">
              <div class="d-flex align-items-center mb-2 mb-md-3">
                <div class="movieTitle">{{ cinemaDetails.CinemaName }}</div>
                <!-- Fav Cinema -->
                <div
                  class="ml-2 favourite-cinema"
                  v-on:click="addtoFav()"
                  :class="cinemaDetails.favourite ? 'check' : ''"
                ></div>

                <label class="mb-0" for="fav">
                  Favourite
                  <span v-if="!cinemaDetails.favourite"></span>
                </label>
              </div>
              <!-- Fav End -->
              <div class="movieInfo mb-2 mb-md-3 mb-lg-4">
                <div class="small mb-2">Direction</div>
                <div>
                  <a
                    v-if="project == 'ticketak'"
                    target="_blank"
                    :href="
                      'https://www.google.com/maps/search/?api=1&query=' +
                        cinemaDetails.Latitude +
                        ',' +
                        cinemaDetails.Longitude
                    "
                  >
                    <img
                      src="@/assets/img/map.svg"
                      alt="location-img"
                      height="auto"
                      width="18px"
                    />
                    {{ cinemaDetails.Address }}
                  </a>
                  <a
                    v-else
                    target="_blank"
                    :href="
                      'https://www.google.com/maps/search/?api=1&query=' +
                        cinemaDetails.Latitude +
                        ',' +
                        cinemaDetails.Longitude
                    "
                  >
                    <img
                      src="@/assets/img/map.svg"
                      alt="location-img"
                      height="auto"
                      width="22px"
                    />
                    {{ cinemaDetails.Address }}
                  </a>

                  <div class="mt-2">
                    <!-- <span>location link</span> -->
                  </div>
                </div>
              </div>

              <div class="movieInfo">
                <div class="small mb-2">Types of Screens/Formats</div>
                <div>
                  <div class="mb-3 lh-1-5">
                    <p>{{ cinemaDetails.ScreenTypes }}</p>
                    <!-- <span class="format">2D</span>
                    <span class="format">3D</span>
                    <span class="format">4DX</span>-->
                  </div>
                </div>
              </div>
            </div>

            <!-- SECOND ROW -->
            <div class="movieInfo mb-2 mb-md-3 mb-lg-4">
              <div class="small">Cinema Info</div>
              <div>{{ cinemaDetails.CinemaType }}</div>
            </div>

            <!-- THIRD ROW -->
            <div class="movieInfo mb-2 mb-md-3 mb-lg-4">
              <div class="small">F&amp;B Available</div>
              <div>{{ cinemaDetails.FnB }}</div>
              <!-- <ul class="list-inline cinemaListNew">
                <li class="list-inline-item">Popcorn</li>
                <li class="list-inline-item">Tea</li>
                <li class="list-inline-item">Coffee</li>
                <li class="list-inline-item">Popcorn</li>
                <li class="list-inline-item">etc..</li>
              </ul>-->
            </div>
          </div>
        </div>

        <div class="d-none">
          <div class="row ml-0 mr-0 mb-3">
            <div class="col-md-4 col-sm-4 col-4">
              <div class="responsive-show">
                <div class="movieInfo d-md-none d-block">
                  <div class="small">Interested</div>
                  <img
                    src="@/assets/img/icons/heart-filled.svg"
                    height="auto"
                    width="16px"
                    alt
                  />
                  {{ movieDetails.interestedcount }}
                </div>
              </div>
            </div>

            <div class="col-md-4 col-sm-4 col-4">
              <div class="responsive-show">
                <div class="movieInfo d-md-none d-block">
                  <div class="small">Critics Rating</div>
                  <star-rating
                    :show-rating="true"
                    :rating="movieDetails.criticsrating"
                    :increment="0.5"
                    :inline="true"
                    :read-only="true"
                    active-color="#e5007d"
                    :star-size="13"
                  ></star-rating>
                </div>
              </div>
            </div>

            <div class="col-md-4 col-sm-4 col-4">
              <div class="responsive-show">
                <div class="movieInfo d-md-none d-block">
                  <div class="small">User Rating</div>
                  <star-rating
                    :show-rating="true"
                    :rating="movieDetails.useravaragerating"
                    :increment="0.5"
                    :inline="true"
                    :read-only="true"
                    active-color="#e5007d"
                    :star-size="13"
                  ></star-rating>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div class="section-space"></div>

      <section class>
        <div class>
          <div class="section-menu mb-3">
            <div class="section-title d-none d-md-block">Movies</div>
            <ul class="status-filter">
              <li
                class
                v-bind:class="{ active: visibleShows.title == 'All Shows' }"
                v-on:click="visibleShows = Shows[0].show"
              >
                All Shows
              </li>
              <!-- <li
              class
              v-bind:class="{ active: visibleShows.title == 'Coming Soon' }"
              v-on:click="visibleShows = Shows[1]"
            >Coming Soon</li>
            <li
              class
              v-bind:class="{ active: visibleShows.title == 'Art House' }"
              v-on:click="visibleShows = Shows[2]"
              >Art House</li>-->
            </ul>
          </div>

          <div class="row">
            <div
              class="col-12 col-sm-12 col-md-4 col-lg-3 col-xl-2 d-none d-md-block"
            >
              <div
                class="accordian-container"
                v-for="(filter, filterKey) in filters"
                :key="filterKey"
              >
                <button
                  class="btn-accordian no-focus"
                  :class="
                    selectedFilter &&
                    selectedFilter[filter.filter_key] &&
                    selectedFilter[filter.filter_key].length > 0
                      ? 'active'
                      : ''
                  "
                  @click="onToggle(filter.collapseId)"
                >
                  <img :src="filter.icon" height="15px" width="15px" />
                  {{ filter.filter_name }}
                </button>
                <b-collapse
                  class="accordian-container"
                  accordion="my-accordion"
                  role="tabpanel"
                  :id="filter.collapseId"
                >
                  <div
                    class="btn-accordian-child d-flex align-items-center"
                    v-for="(filterList, filterListKey) in filter.all_filter"
                    :key="filterListKey"
                  >
                    <input
                      v-on:click="
                        onClickFilter(
                          filter.filter_key,
                          filterList.value,
                          filterListKey,
                          filterList.title
                        )
                      "
                      :id="filter.filter_key + filterListKey"
                      :checked="
                        selectedFilter[filter.filter_key] &&
                        filterList.value ==
                          selectedFilter[filter.filter_key][filterKey]
                          ? true
                          : false
                      "
                      type="checkbox"
                    />
                    <label
                      class="mb-0"
                      :for="filter.filter_key + filterListKey"
                      >{{ filterList.title }}</label
                    >
                  </div>

                  <!-- <ul class="filter-list accordian-container">
                    <li
                      class="btn-accordian-child"
                      v-for="(filterList ,filterListKey) in filter.all_filter"
                      :key="filterListKey"
                    >
                      <label for="date">{{filterList.title}}</label>
                      <input id="date" type="checkbox" />
                    </li>
                  </ul>-->
                </b-collapse>
              </div>
              <Advertise />
            </div>
            <div class="col-12 col-sm-12 col-md-4 col-lg-3 col-xl-2 d-none">
              <div class="accordian-container">
                <button v-b-toggle.languages class="btn-accordian">
                  <img
                    src="@/assets/img/svg/icon-world.svg"
                    height="18px"
                    width="18px"
                    alt
                  />
                  {{ dropDowns.languages.selected.LanguageName }}
                </button>
                <b-collapse class="btn-accordian-content" id="languages">
                  <button
                    v-b-toggle.languages
                    v-for="(lang, languageListIndex) in dropDowns.languages
                      .list"
                    :key="languageListIndex"
                    class="btn-accordian-child"
                    v-on:click="filterData(lang, 'language')"
                  >
                    {{ lang.LanguageName }}
                  </button>
                </b-collapse>
              </div>
              <div class="accordian-container">
                <button v-b-toggle.genre class="btn-accordian">
                  <img
                    src="@/assets/img/icon-genre.png"
                    height="18px"
                    width="18px"
                    alt
                  />
                  {{ dropDowns.genre.selected.Genre }}
                </button>
                <b-collapse class="btn-accordian-content" id="genre">
                  <button
                    v-b-toggle.genre
                    v-for="(genre, genreListIndex) in dropDowns.genre.list"
                    :key="genreListIndex"
                    class="btn-accordian-child"
                    v-on:click="filterData(genre, 'genre')"
                  >
                    {{ genre.Genre }}
                  </button>
                </b-collapse>
              </div>
            </div>

            <div class="col-12 col-sm-12 col-md-8 col-lg-9 col-xl-10">
              <div>
                <ul class="list-inline">
                  <li
                    v-for="(filter, filterKey) in filtersChips"
                    :key="filterKey"
                    class="list-inline-item"
                  >
                    <div class="badge badge-pill bg-pink text-white">
                      {{ filter.title }}
                      <button
                        v-on:click="
                          onRemoveFilterChips(
                            filter.filter_key,
                            filter.value,
                            filterKey
                          )
                        "
                        class="btn-badge-close"
                      >
                        x
                      </button>
                    </div>
                  </li>
                  <li
                    v-if="filtersChips.length > 0"
                    class="list-inline-item d-none"
                  >
                    <div class="badge badge-pill bg-pink text-white">
                      Clear All
                      <button
                        v-on:click="onClearAllFilters()"
                        class="btn-badge-close"
                      >
                        x
                      </button>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="row movie-listing">
                <div
                  v-for="(movie, index222) in visibleShows"
                  :key="index222"
                  class="col-6 col-sm-6 col-md-6 col-lg-4 col-xl-3 mb-4"
                >
                  <router-link
                    :to="{
                      name: 'movie',
                      params: {
                        movieID: movie.id,
                        cinemaID: '0',
                        props: {
                          selectedFilter,
                          cat_id: visibleShows['cat_id']
                        }
                      }
                    }"
                  >
                    <div class="movie-card">
                      <span
                        v-if="movie.flagname.length > 0"
                        class="advance-booking"
                        >{{ movie.flagname }}</span
                      >
                      <img :src="movie.movie_card_img" class="movie-poster" />
                      <div class="movie-content">
                        <div class="movie-name">{{ movie.title }}</div>
                        <div class="d-flex flex-wrap">
                          <div class="text-dark">
                            <span>{{ movie.rated }}</span>
                            <span>|</span>
                            <span>{{ movie.genre }}</span>
                            <span>|</span>
                            <span>{{ movie.lang }}</span>
                            <span>|</span>
                            <span class="format">{{ movie.format }}</span>
                          </div>
                        </div>

                        <hr />

                        <!-- <div class="d-flex flex-wrap mb-3 mb-md-0">
                          <div class="movie-release mr-2 d-flex align-items-center">
                            <img
                              src="@/assets/img/icon-calender.png"
                              class="mr-1"
                              height="15px"
                              width="15px"
                            >
                            {{movie.release}}
                          </div>

                          <div class="movie-duration d-flex align-items-center">
                            <img
                              src="@/assets/img/icon-clock.png"
                              class="mr-1"
                              height="15px"
                              width="15px"
                            >
                            {{movie.runtime}}
                          </div>
                        </div>-->
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

import Slick from "vue-slick";
import UpCommingMovies from "@/components/partials/UpComingMovies.vue";
import StarRating from "vue-star-rating";
Vue.component("star-rating", StarRating);
import $ from "jquery";
import { TokenService } from "@/services/storage.service";
import { makeRequest } from "@/helper/internet.js";
import { validationMixin } from "vuelidate";
import { EventBus } from "@/main";
import Advertise from "@/components/partials/advertise.vue";
import { PROJECT, metaInfo } from "@/helper/constant.js";

export default {
  name: "movieDetails",
  components: {
    Slick,
    UpCommingMovies,
    Advertise
  },
  // metaInfo: {
  //   title: "Cinema Details",
  //   titleTemplate: null
  // },

  metaInfo: metaInfo,

  data() {
    return {
      jsonld: "",
      project: PROJECT,
      ratingDetails: {
        currentUserRating: 4
      },
      filterModal: false,
      crewSlider: {
        arrows: true,
        infinite: false,
        slidesToShow: 6,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]
      },

      castSlider: {
        arrows: true,
        infinite: false,
        slidesToShow: 6
      },
      Shows: [],
      Banners: [],
      visibleShows: [],
      filters: [],
      selectedFilter: {},
      dropDowns: {
        languages: {
          selected: {
            LanguageName: "All Languages"
          },
          list: []
        },
        cinemaChain: {
          selected: {
            OrganizationName: "All Cinemas"
          },
          list: []
        },
        genre: {
          selected: {
            Genre: "All Genre"
          },
          list: []
        }
      },
      msg: "Welcome to Your HOMEPAGE",
      slickOptions: {
        slidesToShow: 3
      },
      cinemaID: "",
      shows: [],
      youtubeURL: "i4K3os977h4",
      movieDetails: {},
      allDates: [],
      allcinemas: [],
      selectedDate: "",
      selectedCinema: "",
      selectedFormat: "",
      movieID: "",
      trailer: {
        url: "",
        thumbnail: ""
      },
      filtersChips: [],
      rating: {
        userRatings: [],
        criticRatings: [],
        userRating: 0,
        currentUserRatingDetails: {
          title: "",
          currentUserRating: "",
          content: ""
        },

        criticRating: 0,
        criticRatingDetails: [],
        currentUserRating: {}
      },
      cinemaDetails: {}
    };
  },
  mixins: [validationMixin],
  watch: {
    $route(to, from) {
      alert("to :", to);
      console.log("from :", from);
      // react to route changes...
    }
  },
  beforeMount() {
    this.cinemaID = this.$route.params.cinemaId;
    console.log("this.cinemaID :", this.cinemaID);
    this.fetchCinemaDetails();
    this.selectedFilter["cinema_name"] = this.cinemaID;
    this.getNowShowingData();
    this.getAllFilters();
  },
  methods: {
    checkSignIn: function() {
      EventBus.$emit("openSignInModal");
    },
    addtoFav() {
      let token = TokenService.getToken();
      if (token) {
        let payload = {
          CinemaID: this.cinemaID,
          Like: 1,
          FireBaseID: "",
          favourite: !this.cinemaDetails.favourite
        };
        makeRequest("/AddFavourite", "POST", token, payload)
          .then(response => {
            const { error, res } = response;
            if (res.data) {
              this.cinemaDetails.favourite = !this.cinemaDetails.favourite;
            }
          })
          .catch(error => {});
      } else {
        this.checkSignIn();
      }
    },
    onToggle: function(index) {
      this.$root.$emit("bv::toggle::collapse", index);
    },
    onRemoveFilterChips(filter_key, value, index) {
      this.filtersChips.splice(index, 1);
      let _index = this.selectedFilter[filter_key].indexOf(value);

      if (_index > -1) {
        this.selectedFilter[filter_key].splice(_index, 1);
      }
      this.getNowShowingData();
    },
    onClearAllFilters: function() {
      this.filtersChips = [];
      this.selectedFilter = {};
      this.getNowShowingData();
    },
    onClickFilter: function(filter_key, value, index, title) {
      let __index = this.filtersChips.findIndex(x => x.title === title);

      if (__index > -1) {
        this.filtersChips.splice(__index, 1);
      } else {
        this.filtersChips.push({
          title: title,
          filter_key: filter_key,
          value: value
        });
      }
      let obj = {};
      obj[filter_key] = [];

      this.selectedFilter = {
        ...obj,
        ...this.selectedFilter
      };
      let _index = this.selectedFilter[filter_key].indexOf(value);
      if (_index > -1) {
        this.selectedFilter[filter_key].splice(_index, 1);
      } else {
        this.selectedFilter[filter_key].push(value);
      }
      this.getNowShowingData();
    },
    fetchCinemaDetails() {
      let token = null;
      let payload = {
        CinemaID: this.cinemaID
      };
      makeRequest("/GetcinemaByID", "POST", null, payload)
        .then(response => {
          const { error, res } = response;
          if (!error && res.data) {
            if (!error) {
              console.log("res.data :", res.data);
              this.cinemaDetails = res.data.CinemaList[0];
              this.jsonld = res.data.meta;
              console.log("acd", this.cinemaDetails.Slug);
              //window.location.href = "/cinemas/" + this.cinemaDetails.Slug;
              this.$router.push({
                name: "cinema",
                params: { cinemaId: this.cinemaDetails.Slug }
              });
            }
          } else {
            console.log("Response Error ");
          }
        })
        .catch(error => {
          console.log("Error", error);
        });
    },
    getAllFilters: function() {
      let payload = {
        FilterType: "CinemaDetails",
        CinemaID: this.cinemaID
      };
      makeRequest("/GetAllFilter", "POST", null, payload)
        .then(response => {
          const { error, res } = response;
          if (!error) {
            this.filters = [];
            res.data.Filters.map((x, index) => {
              this.filters.push({
                ...x,
                collapseId: "collapse-" + (index + 1)
              });
            });
            console.log("filter", res.data);
            this.dropDowns.languages.list = res.data.List.Language;
            this.dropDowns.languages.list.push({
              LanguageName: "All Languages"
            });
            this.dropDowns.genre.list = res.data.List.Genre;
            this.dropDowns.genre.list.push({
              Genre: "All Genre"
            });
          } else {
            console.log("Response Error ");
          }
        })
        .catch(error => {
          console.log("Error", error);
        });
    },
    getNowShowingData: function() {
      this.showLoading();
      this.Shows = [];
      this.visibleShows = [];
      let payload = {
        CinemaID: this.cinemaID
      };
      if (this.dropDowns.languages.selected.LanguageName != "All Languages") {
        payload.MovieLanguageID = this.dropDowns.languages.selected.LanguageName;
      }
      if (this.dropDowns.genre.selected.Genre != "All Genre") {
        payload.Genre = this.dropDowns.genre.selected.Genre;
      }
      Object.keys(this.selectedFilter).map(x => {
        if (this.selectedFilter[x].length > 0) {
          payload[x] = this.selectedFilter[x].toString();
        }
      });
      makeRequest("/GetAllShow", "POST", null, payload)
        .then(response => {
          this.hideLoading();
          const { error, res } = response;
          // console.log("movie", error, res);
          this.Shows = res.data.Shows;
          this.Banners = res.data.Banners;

          this.Shows.map(shows => {
            shows.show.map(x => {
              x.url = "/movie/" + x.id + "/" + this.cinemaID;
            });
          });
          this.Shows.map((x, index) => {
            if (x.cat_id == "3") {
              delete this.Shows[index];
            }
          });
          this.Shows.map((x, index) => {
            // this.visibleShows.push(x.show);
            this.visibleShows = this.visibleShows.concat(x.show);
          });
          this.visibleShows["title"] = "All Shows";

          // this.visibleShows = this.Shows[1];
          // this.visibleShows = this.Shows[2];
          // this.newReleases = res.data.Shows[0].show;
          // this.newReleases.map(x => {
          //   x.url = "/movie/" + x.id;
          // });
        })
        .catch(error => {
          console.log("Error", error);
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/components/pages/cinemaDetails.vue